import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ElementsPriceDetails from '../../../../ElementsPriceDetails/ElementsPriceDetails';
import { useTheme } from '../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import { isFareOrServicesNotEmpty, isRetentionNotEmpty } from '../../utils';
import TotalRefund from '../TotalRefund/TotalRefund';
const Details = ({ prices, className }) => {
    const { t } = useTranslation('Refund');
    const { Details: css } = useTheme('PriceDetails');
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement(TotalRefund, { className: css.totalRefund, price: prices.priceToPay }),
        React.createElement(ElementsPriceDetails, { elements: prices.priceDetails.refunded }),
        isFareOrServicesNotEmpty(prices.priceDetails.refunded) && React.createElement("div", { className: css.dashedSeparator }),
        React.createElement(PriceItem, { name: t('Total has been paid'), className: css.priceHeadTitle, price: prices.priceDetails.paid.sum }),
        React.createElement("div", { className: css.dashedSeparator }),
        isRetentionNotEmpty(prices) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css.priceHeadTitle }, t('Retentions')),
            React.createElement(ElementsPriceDetails, { elements: prices.priceDetails.retention }),
            React.createElement("div", { className: css.dashedSeparator }))),
        React.createElement(PriceItem, { name: t('Non refundable sum'), className: css.priceHeadTitle, price: Object.assign(Object.assign({}, prices.priceDetails.paid.sum), { amount: prices.priceDetails.paid.sum.amount - prices.priceToPay.amount * -1 }) })));
};
export default Details;
